/**
 * All recognised waterfall checkpoint names.
 *
 * This const array is the single source of truth for both the runtime
 * allowlist (used by SchemaEnforcementPlugin) and the TypeScript union type.
 * To add a new checkpoint, add it here — both consumers update automatically.
 */
export const PREDEFINED_CHECKPOINTS = [
    "Code_S",
    "Code_E",
    "Data_S",
    "Data_E",
    "Network_S",
    "Network_E",
    "Render_S",
    "Render_E",
    "GQL_Link_S", // query submitted to apollo client
    "GQL_Link_E", // result being returned from apollo client
    "GQL_Bridge_S", // query being sent from main thread to worker
    "GQL_Bridge_E", // result received on main thread from worker
    "GQL_Bridge_Error", // error received on main thread from worker
] as const;

export type PredefinedCheckpoint = (typeof PREDEFINED_CHECKPOINTS)[number];
